import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "../../../../components/utils/cn";
import { LeadButton, type LeadButtonProps } from "./LeadButton";
import { getImageUrl } from "../../../../utils/image";
import { Avatar } from "../../../../components";

interface Props extends LeadButtonProps {
  title?: string;
  logoId?: string;
  companyName?: string;
}

export const LeadAssignmentButton = ({
  title,
  logoId,
  companyName,
  className,
  ...props
}: Props) => (
  <LeadButton {...props} className={cn("flex-1 min-w-0 flex", className)}>
    {logoId ? (
      <Avatar
        // TODO: Default image
        imageUrl={logoId ? getImageUrl(logoId) : undefined}
        alt={"logo"}
        className="w-10 h-10 shrink-0 ml-2"
      />
    ) : companyName ? (
      <div className="w-14 h-14 p-2 min-w-[56px] flex items-center justify-center shrink-0">
        <div className="bg-gray-5 rounded-2xl w-full h-full flex items-center justify-center">
          <span className="text-white font-semibold text-2xl">{companyName[0]}</span>
        </div>
      </div>
    ) : (
      <div className="w-10 h-10 shrink-0 ml-2 flex items-center justify-center">
        <FontAwesomeIcon icon={faBriefcase} className="w-5 h-5 text-black" />
      </div>
    )}

    <div className="flex flex-col min-w-0">
      <p className="text-wrap">{title ?? "Assignment"}</p>
      <p className="truncate">{companyName ?? ""}</p>
    </div>
  </LeadButton>
);

LeadAssignmentButton.displayName = "LeadAssignmentButton";
